import { applyMiddleware, compose, createStore } from 'redux'
import { createEpicMiddleware } from 'redux-observable'
import { browserHistory } from 'react-router'
import { routerMiddleware } from 'react-router-redux'
import { GAEventTracker, googleAnalyticsMiddleware } from '../util/googleAnalytics'
import makeRootReducer from './reducers'
import { rootEpic } from './epics'
import { localize } from '@daptiv/localize'
import { VapiClient } from '../ajax/vapiClient'

export default (initialState = {}) => {
  // ======================================================
  // Middleware Configuration
  // ======================================================

  const epicMiddleware = createEpicMiddleware({
    dependencies: {
      vapiClient: new VapiClient(),
      localize
    }
  })
  const middleware = [
    epicMiddleware,
    routerMiddleware(browserHistory),
    googleAnalyticsMiddleware(new GAEventTracker(ga))
  ]

  // ======================================================
  // Store Enhancers
  // ======================================================
  const enhancers = []

  let composeEnhancers = compose

  if (__DEV__) {
    const composeWithDevToolsExtension = window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__
    if (typeof composeWithDevToolsExtension === 'function') {
      composeEnhancers = composeWithDevToolsExtension
    }
  }

  // ======================================================
  // Store Instantiation and HMR Setup
  // ======================================================
  const store = createStore(
    makeRootReducer(),
    initialState,
    composeEnhancers(
      applyMiddleware(...middleware),
      ...enhancers
    )
  )
  store.asyncReducers = {}

  epicMiddleware.run(rootEpic)

  if (module.hot) {
    module.hot.accept('./reducers', () => {
      const reducers = require('./reducers').default
      store.replaceReducer(reducers(store.asyncReducers))
    })
  }

  return store
}



// WEBPACK FOOTER //
// ./src/store/createStore.js